import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ServerFormComponent } from '../server-form/server-form.component';
import { Server } from '../shared/models/server.model';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServiceService } from '../shared/service/service.service';
import { AuthService } from 'src/app/auth/auth.service';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { EncryptionHandler } from '../../../auth/encryption-handler';

@Component({
  selector: 'app-server-list',
  templateUrl: './server-list.component.html',
  styleUrls: ['./server-list.component.scss']
})
export class ServerListComponent implements OnInit {

  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['name', 'url', 'environment', 'user', 'password', 'actions'];

  loggedInUser: any;

  isLoading: boolean = true;

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private service: ServiceService,
    private authService: AuthService,
  ) {
    this.dataSource = new MatTableDataSource<any>([]);
  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.authService.getUser()
      .pipe(
        switchMap((user: any) => (user ? this.service.getByOwnerId(user.id) : []))
      )
      .subscribe((servers: any) => {
        this.isLoading = false;
        this.dataSource = new MatTableDataSource(servers);
      }, () => this.isLoading = false);
  }

  addOrUpdateServer(server?: Server) {
    this.dialog.open(ServerFormComponent, {
      width: "50%",
      data: server
    });
  }

  openWindow(url: string) {
    if (!/^http[s]?:\/\//.test(url)) {
      url = 'http://' + url;
    }
    window.open(url, '_blank');
  }

  setAsCopied(element) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = element.value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.snackBar.open('Password copied!', 'OK', { duration: 2000 });
  }

  isVisible(element) {
    element.style.background = '#f1f1f1';

    if (element.type === 'password')
      element.setAttribute('type', 'text');
    else
      element.setAttribute('type', 'password');
  }

  deleteServer(server: Server) {
    this.service.delete(server)
      .then(() => {
        this.snackBar.open('Server has been removed.', 'OK', { duration: 2000 });
      })
      .catch(() => {
        this.snackBar.open('Error when trying to remove the server.', 'OK', { duration: 2000 });
      });
  }

  openConfirmDialog(server: Server) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px"
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult)
        this.deleteServer(server);
    });
  }

  sortData(sort: Sort) {
    if (sort.active && sort.direction !== '') {
      this.dataSource.data = this.dataSource.data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'name': return this.compare(a.name, b.name, isAsc);
          case 'environment': return this.compare(a.environment, b.environment, isAsc);
          case 'user': return this.compare(a.user, b.user, isAsc);
          default: return 0;
        }
      });
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  decrypt(ciphertext: string) {
    return EncryptionHandler.decryptToAES256(ciphertext);
  }
}
